// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 214) return "wp-content/themes/bel-architecten-theme/public/scripts/app/214.js";
	if (chunkId === 162) return "wp-content/themes/bel-architecten-theme/public/scripts/app/162.js";
	if (chunkId === 274) return "wp-content/themes/bel-architecten-theme/public/scripts/app/274.js";
	if (chunkId === 442) return "wp-content/themes/bel-architecten-theme/public/scripts/app/442.js";
	if (chunkId === 40) return "wp-content/themes/bel-architecten-theme/public/scripts/app/40.js";
	if (chunkId === 126) return "wp-content/themes/bel-architecten-theme/public/scripts/app/126.js";
	// return url for filenames based on template
	return undefined;
};